import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { PageHero } from "../components/sections";
import { Reveal } from "../components/Reveal";
import { FAQS, IMAGES } from "../data/site";

export default function FAQ() {
  return (
    <div>
      <PageHero eyebrow="Help Centre" title="Frequently asked questions" subtitle="Everything you need to know before you travel with Life Line." image={IMAGES.nepal} />

      <section className="ll-container ll-section max-w-3xl">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="ll-card border-none px-6">
                <AccordionTrigger className="text-left font-display text-lg md:text-xl font-bold text-[#0A221C] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A5D58] text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal className="text-center mt-16">
          <p className="text-[#4A5D58] text-lg">Still have questions?</p>
          <Link to="/contact" className="btn-primary mt-5">Talk to a Travel Expert <ArrowRight size={18} /></Link>
        </Reveal>
      </section>
    </div>
  );
}
